import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import theme from '../../../muiTheme.js';

class JurisdictionalTextFilter extends Component {


  handleChange = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {

    const textFileStyle = {
      inputStyle: {
        color: theme.palette.canvasColor
      },
      floatingLabelStyle: {
        color: theme.palette.secondaryTextColor
      },
      floatingLabelFocusStyle: {
        color: theme.palette.canvasColor
      }
    };

    return (
      <div className="filter-item filter-item-text-field">
        <TextField
          style={{width: "200px"}}
          value={this.props.value || ""}
          floatingLabelText={this.props.label}
          floatingLabelStyle={textFileStyle.floatingLabelStyle}
          floatingLabelFocusStyle={textFileStyle.floatingLabelFocusStyle}
          inputStyle={textFileStyle.inputStyle}
          onChange={this.handleChange}
          />
          {this.props.iconToShow}
      </div>
    );
  }

}

export default JurisdictionalTextFilter;
